import React from "react";
import SkeletonBox from "./skeleton";

const SharesSkeleton = () => {
    return (
        <div className="mx-auto w-full px-6 pt-4 md:w-[1232px] md:px-0 pb-16">
            <div className="mb-s15 w-full md:rounded-2xl md:py-s15">
                <SkeletonBox classname="h-[22px] md:h-[40px] w-[220px]" />
                <div className="mt-s9 flex flex-wrap items-start gap-6 text-nowrap rounded-2xl border border-neutralOpacityDark-10 px-s7 py-s8 md:border-none md:p-0">
                    {[1, 2, 3].map((item) => (
                        <div
                            className="hidden w-full md:block md:w-1/5"
                            key={`desktop-item-${item}`}
                        >
                            <SkeletonBox classname="h-[22px] w-[122px] mb-3" />
                            <SkeletonBox classname="h-[30px] w-[122px]" />
                        </div>
                    ))}
                    {[1, 2, 3, 4].map((item) => (
                        <div
                            className={`block w-[45%] md:hidden ${item === 2 ? "invisible" : ""}`}
                            key={`mobile-item-${item}`}
                        >
                            <SkeletonBox classname="h-[22px] w-[110px] mb-3" />
                            <SkeletonBox classname="h-[30px] w-[90px]" />
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex gap-6">
                <SkeletonBox classname="h-[22px] w-[110px] mb-3" />
                <SkeletonBox classname="h-[22px] w-[130px] mb-3" />
                <SkeletonBox classname="h-[22px] w-[130px] mb-3" />
            </div>
            <div className="mt-2 border-b border-dotted border-gray-400" />

            <div className="mt-8 grid !w-full grid-cols-1 gap-9 px-2u transition-[max-height] duration-500 ease-in-out md:max-h-max md:grid-cols-3 md:px-0">
                {Array.from({ length: 6 }).map((_, index) => (
                    <div
                        key={index}
                        className="h-[467px] md:w-[384px] rounded-xl border border-neutralOpacityDark-20 p-s9"
                    >
                        <div className="flex gap-2">
                            <SkeletonBox classname="h-[72px] w-[72px]" />
                            <div className="mt-4 flex flex-col gap-2">
                                <SkeletonBox classname="h-[24px] w-[130px]" />
                                <SkeletonBox classname="h-[12px] w-[60px]" />
                            </div>
                        </div>
                        <div className="mt-2 border-b border-dotted border-gray-400" />
                        <div className="grid grid-cols-2">
                            <div className="mt-32 flex flex-col gap-2">
                                <SkeletonBox classname="h-[25px] w-[133px]" />
                                <SkeletonBox classname="h-[20px] w-[90px]" />
                            </div>
                            <div className="mt-32 flex flex-col gap-2">
                                <SkeletonBox classname="h-[25px] w-[133px]" />
                                <SkeletonBox classname="h-[20px] w-[90px]" />
                            </div>
                            <div className="mt-8 flex flex-col gap-2">
                                <SkeletonBox classname="h-[25px] w-[133px]" />
                                <SkeletonBox classname="h-[20px] w-[90px]" />
                            </div>
                            <div className="mt-8 flex flex-col gap-2">
                                <SkeletonBox classname="h-[25px] w-[133px]" />
                                <SkeletonBox classname="h-[20px] w-[90px]" />
                            </div>
                            <div className="mt-8 flex flex-col gap-2">
                                <SkeletonBox classname="h-[40px] md:w-[320px] w-[270px]" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <div className="flex mt-8 justify-center">
            <SkeletonBox classname="h-[49px] w-[133px]" />
            </div> 
        </div>
    );
};

export default SharesSkeleton;
